import React, { useContext } from "react";
import { Button, InputCheckbox, Modal } from "@goodfill/ui-components";
import { arrayDeepEqual, toggleInArray } from "@goodfill/array";
import { CorporateBondId } from "@goodfill/domain-properties";
import { PricedBond } from "../PricedBond";
import { BatchBuyDialog } from "./BatchBuyDialog";
import { Icon } from "@blueprintjs/core";
import "./SelectedToBatchButContext.scss";

interface Props {
  selected: CorporateBondId[];
  setSelected: (value: CorporateBondId[]) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (vale: boolean) => void;
  onRowRemove: (bondId: CorporateBondId) => void;
}

export const SelectedToBatchBuyContext = React.createContext<Props>({
  selected: [],
  setSelected: () => undefined,
  isDialogOpen: false,
  setIsDialogOpen: () => undefined,
  onRowRemove: () => undefined,
});

export const BatchBuyButtons = ({ rows }: { rows: PricedBond[] }) => {
  const { selected, setSelected, setIsDialogOpen } = useContext(SelectedToBatchBuyContext);

  const allIds = rows.map((a) => a.bondIdCusip).sort();

  const isAllSelected = arrayDeepEqual(allIds, selected);

  const isAnyAvailableToBuy = allIds.length > 0;

  return isAnyAvailableToBuy ? (
    <div className="flex sm:flex-row gap-2 sm:w-96 sm:mr-10 flex-col m-auto w-[72%]">
      <Button
        disabled={!isAnyAvailableToBuy}
        fill
        primary={true}
        grouped
        onClick={() => setSelected(isAllSelected ? [] : allIds)}
      >
        Select {isAllSelected ? "none" : "all"}
      </Button>
      <Button fill red={true} grouped onClick={() => setIsDialogOpen(true)} disabled={selected.length === 0}>
        Buy {selected.length} selected
      </Button>
    </div>
  ) : null;
};

export const BatchBuyRowCheckbox = ({ rowId }: { rowId: CorporateBondId }) => {
  const { selected, setSelected } = useContext(SelectedToBatchBuyContext);

  return (
    <InputCheckbox
      className="BatchButRowCheckbox_absoluteTop"
      checked={selected.includes(rowId)}
      onChange={() => setSelected(toggleInArray(rowId, selected).sort())}
    />
  );
};

export const BatchBuyModal = ({ rows }: { rows: readonly PricedBond[] }) => {
  const { selected, isDialogOpen, setIsDialogOpen } = useContext(SelectedToBatchBuyContext);

  return (
    <Modal isActive={isDialogOpen} setIsActive={(isActive) => setIsDialogOpen(isActive)}>
      {isDialogOpen ? <BatchBuyDialog rows={rows.filter((row) => selected.includes(row.bondIdCusip))} /> : null}
    </Modal>
  );
};

export const BatchRemoveRow = ({ rowId, disabled }: { rowId: CorporateBondId; disabled: boolean }) => {
  const { onRowRemove } = useContext(SelectedToBatchBuyContext);

  return (
    <Button onClick={() => onRowRemove(rowId)} disabled={disabled}>
      <Icon icon="trash" />
    </Button>
  );
};
